// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CaseActivityCard_root__nqP\\+c {
  animation-name: CaseActivityCard_heigthChangeBack__H4jwe;
  animation-duration: 700ms;
  position: relative;
  background: white;
  border: 1px solid lightgray;
  border-radius: 6px;
}

.CaseActivityCard_root__nqP\\+c.CaseActivityCard_priority__rocBa,
.CaseActivityCard_rootAnimation__SDhO3.CaseActivityCard_priority__rocBa {
  border: 1px solid var(--color-theme-10);
}

/* Must win over .root / .rootAnimation border shorthand when both apply */
.CaseActivityCard_root__nqP\\+c.CaseActivityCard_root_dotted_border__WRBQH,
.CaseActivityCard_rootAnimation__SDhO3.CaseActivityCard_root_dotted_border__WRBQH {
  border: 1px dashed lightgray;
}

.CaseActivityCard_priority_pin__VxqFL {
  position: absolute;
  top: -15px;
  left: -15px;
  color: var(--color-theme-blue);
  font-size: 15px;
  transform: rotate(-45deg);
  z-index: 1;
}

.CaseActivityCard_received_email_container__Szs7t {
  padding: 15px;
}

.CaseActivityCard_rootFlex__Wx0CA {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  margin: 8px 8px;
}

.CaseActivityCard_rootAnimation__SDhO3 {
  animation-name: CaseActivityCard_heigthChange__cYFhT;
  animation-duration: 1500ms;
  overflow: hidden;
  position: relative;

  background: white;
  border: 1px solid lightgray;
  border-radius: 6px;
}

/* Pin sits outside the box (negative top/left); overflow:hidden would clip it when expanded */
.CaseActivityCard_rootAnimation__SDhO3.CaseActivityCard_priority__rocBa {
  overflow: visible;
}

.CaseActivityCard_left_container__r6s7I {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 115px;
}

.CaseActivityCard_left_timestamp__wbHM3 {
  font-size: 10px;
}

.CaseActivityCard_middle_container__jpZIF {
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 165px;
}

.CaseActivityCard_middle_type__2BC4y {
  font-weight: bold;
  margin-bottom: 7px;
}

.CaseActivityCard_middle_user__QYfNI {
  font-size: 12px;
  font-weight: bold;
}

/* Shared content rows (email / scheduled / letter preview) — replaces repeated inline styles */
.CaseActivityCard_content_email_meta__Y2Aqo {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 400px;
  white-space: nowrap;
  color: #000;
  font-size: 12px;
  margin-top: 2px;
}

.CaseActivityCard_content_subject_expanded__hhup6 {
  width: 400px;
}

.CaseActivityCard_content_subject_ellipsis__7vDvD {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 400px;
  white-space: nowrap;
}

.CaseActivityCard_type_subtext_scheduled_template__8niyK {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 180px;
  white-space: nowrap;
}

.CaseActivityCard_letter_status_flex_row__Phb-e {
  display: flex;
  width: 400px;
}

.CaseActivityCard_letter_status_text__8ugI2 {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 300px;
  color: #000;
  font-size: 12px;
  margin-top: 2px;
}

.CaseActivityCard_content_secondary_line__8Cmlh {
  font-size: 12px;
  margin-top: 2px;
}

.CaseActivityCard_mail_status_message__76kFs {
  text-align: center;
}

.CaseActivityCard_attachment_chip__1Dw3F {
  height: 24px;
  margin-right: 4px;
}

.CaseActivityCard_are_you_sure_preline__k-ZCt {
  white-space: pre-line;
}

.CaseActivityCard_info_popup_emphasis__OGRqs {
  font-style: italic;
}

.CaseActivityCard_dialog_actions_compact__A2Vjd {
  padding: 8px 16px 8px 8px;
}

.CaseActivityCard_note_line__CJe7k {
  margin: 0;
  overflow: hidden;
  width: 400px;
  font-size: 16px;
  line-height: 1.2;
  min-height: 1.2em;
}

.CaseActivityCard_note_line_truncated__waxar {
  margin: 0;
  overflow: hidden;
  width: 400px;
  font-size: 16px;
  line-height: 1.2;
  min-height: 1.2em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.CaseActivityCard_note_delete_icon_wrapper__A1yX2 {
  display: flex;
}

.CaseActivityCard_note_collapsed_wrapper__lWBxD {
  height: 39px;
  font-size: 16px;
}

.CaseActivityCard_right_container__4X3cB {
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 474px;
}

.CaseActivityCard_letter_fail_reason__S8A-5 {
  text-align: start;
  margin-inline-start: 40px;
  font-size: 12px;
  color: rgb(210, 177, 12);
}

.CaseActivityCard_right_container_opener__UH6MM {
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
}

.CaseActivityCard_btn_confirm__dv1-7 {
  font-weight: bold !important;
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  margin-top: 10px;
}

.CaseActivityCard_unread_marker__BhXhW {
  border-radius: 10px;
  width: 7px;
  /* z-index: 20; */
  height: 7px;
  background-color: royalblue;
  position: relative;
  top: -29px;
  left: 25px;
  margin-bottom: -7px;
}

.CaseActivityCard_btn_default__gsASm {
  color: var(--color-font-10) !important;

  border: 1px solid rgba(0, 0, 0, 0.23) !important;
  margin-top: 10px;
  margin-right: 10px !important;
}

.CaseActivityCard_btn_default_invisible__tOfMk {
  color: var(--color-font-10) !important;

  border: 1px solid rgba(0, 0, 0, 0.23) !important;
  margin-top: 10px;
  margin-right: 10px !important;
  visibility: hidden;
}
.CaseActivityCard_notePopupTextContainer__qMuLt {
  max-height: 550px;
  overflow-y: auto;
  overflow-x: hidden;
}

.CaseActivityCard_email_iframe__hrK9u {
  width: 100%;
  height: 500px;
  border: none;
}

/* ── Right-side action column (delete, expand, menu) ── */
.CaseActivityCard_right_opener__ZyNjZ {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
}

/* When there's no expand arrow, push the delete icon to the top */
.CaseActivityCard_right_opener_top__I4gpB {
  justify-content: flex-start;
}

/* Unified delete icon across all card types */
.CaseActivityCard_delete_shopping_icon__GB0sm {
  cursor: pointer;
  font-size: 20px !important;
  width: 20px;
  height: 20px;
}

.CaseActivityCard_delete_shopping_icon__GB0sm:hover {
  color: var(--color-theme-red);
}

.CaseActivityCard_delete_icon_disabled__gDbcX {
  color: darkgray;
  cursor: default;
}

.CaseActivityCard_delete_icon_disabled__gDbcX:hover {
  color: darkgray;
}

/* Expand chevron wrapper */
.CaseActivityCard_opener_expand_wrap__H997Q {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.CaseActivityCard_opener_expand_more__In7rO {
  font-size: 20px !important;
  width: 20px;
  height: 20px;
}

.CaseActivityCard_edit_icon__UdFGP {
  cursor: pointer;
}

.CaseActivityCard_notePopupTextContainer__qMuLt::-webkit-scrollbar {
  width: 8px !important;
  display: inherit !important;
  background-color: white !important;
}

.CaseActivityCard_notePopupTextContainer__qMuLt::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 0px !important;
  display: inherit !important;
  width: 10px !important;
}

.CaseActivityCard_notePopupActionsContainer__qZgY0 {
  display: flex;
  flex-direction: row-reverse;
}

.CaseActivityCard_gray__W8223 {
  rotate: 180deg;
}

.CaseActivityCard_btn_confirm__dv1-7 {
  width: 100px;
  margin-left: 15px !important;
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
}

.CaseActivityCard_btn_confirm__dv1-7:hover {
  width: 100px;
  margin-left: 15px !important;
  color: var(--color-theme-white) !important;
  background-color: var(--color-theme-blue) !important;
}

.CaseActivityCard_btn_cancel__I9ceg {
  width: 100px !important;
  border: 1px solid var(--color-font-10) !important;
  color: var(--color-font-10) !important;
}

.CaseActivityCard_btn_cancel__I9ceg:hover {
  width: 100px;
  margin-left: 15px !important;
  color: var(--color-theme-white) !important;
  background-color: var(--color-font-10) !important;
}

.CaseActivityCard_dialogContent__Y6nIq {
  margin-left: 5px;
  margin-bottom: 30px;
}

.CaseActivityCard_mailContainer__NrH4H {
  border-top: 1px solid var(--color-theme-cloud);
  margin-top: 14px;
}

.CaseActivityCard_email_tools__9i3tE {
  background: rgb(247 247 247);
  position: sticky;
  top: 0;

  border-bottom: 1px solid lightgray;
  padding: 4px 4px;
  width: calc(100% + 8px);
}

.CaseActivityCard_email_resend_container__EBIit {
  /* background: rgb(0 0 0 / 3%); */
  display: flex;
  justify-content: space-between;
  position: relative;
  border-bottom: 1px solid lightgray;
  padding: 4px 0px 4px 4px;
  width: calc(100% + 8px);
  right: 8px;
}
.CaseActivityCard_resend_text__H7g9x {
  /* color: var(--color-theme-yellow); */
  color: rgb(233, 170, 12);
  margin: auto 0 auto 10px;
}

.CaseActivityCard_warning_icon__nV6Xy {
  color: var(--color-theme-yellow);
}

.CaseActivityCard_scheduled_text_container__yf71x {
  padding: 8px;
}

.CaseActivityCard_payment_received_container__FyxUM {
  padding: 16px 8px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 160px;
  min-width: 0;
}

.CaseActivityCard_payment_received_company_info_block__pSAJm {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  min-width: 220px;
  max-width: 320px;
  flex: 1 1 220px;
  box-sizing: border-box;
}

.CaseActivityCard_payment_received_company_info_block__pSAJm > div {
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.CaseActivityCard_payment_received_email_block_label__pHAlj {
  min-width: 70px;
  display: inline-block;
  margin-right: 16px;
  margin-bottom: 0;
  text-align: left;
}

.CaseActivityCard_payment_received_address_block__m54R\\+ {
  margin: 0;
  min-width: 220px;
  max-width: 320px;
  flex: 1 1 220px;
  box-sizing: border-box;
}

.CaseActivityCard_payment_received_address_block__m54R\\+ > strong {
  display: block;
  margin-bottom: 10px;
}
.CaseActivityCard_payment_received_email_block_label__pHAlj {
  min-width: 70px;
  display: inline-block;
}

.CaseActivityCard_attachement_row__oPiCV {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.CaseActivityCard_attachment_button_container__f\\+QWu {
  position: absolute;
  right: 0px;
  top: 4px;
}

.CaseActivityCard_license_icon_high__WqKkk {
  color: var(--color-theme-blue);
}

.CaseActivityCard_license_content__rehwW {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
  flex: 1 1;
}

.CaseActivityCard_license_filename__VlJv1 {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}

.CaseActivityCard_license_filename_with_status__OZbnD {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
}

.CaseActivityCard_license_filename_text__Enq6h {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.CaseActivityCard_license_deleted__R0yu3 {
  flex-shrink: 0;
  margin-left: 2px;
}

.CaseActivityCard_license_filename__VlJv1 > a,
.CaseActivityCard_license_filename__VlJv1 > span:not(.CaseActivityCard_license_filename_with_status__OZbnD) {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.CaseActivityCard_license_file_link__T3h6O {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.CaseActivityCard_license_file_link__T3h6O:hover {
  text-decoration: underline;
  color: var(--color-theme-blue);
}

.CaseActivityCard_license_actions__mZHyU {
  display: flex;
  align-items: center;
  gap: 6px;
}

.CaseActivityCard_btn_check_license__EQ5\\+t {
  font-size: 11px !important;
  text-transform: uppercase !important;
  white-space: nowrap;
  color: var(--color-font-10) !important;
  border: 1px solid rgba(0, 0, 0, 0.23) !important;
  padding: 2px 8px !important;
  align-self: center;
  margin: 0 30px !important;
}

@keyframes CaseActivityCard_heigthChange__cYFhT {
  from {
    max-height: 56px;
  }
  to {
    max-height: 4000px;
  }
}

@keyframes CaseActivityCard_heigthChangeBack__H4jwe {
  from {
    max-height: 900px;
  }
  to {
    max-height: 56px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/@_components/CaseActivityCard/CaseActivityCard.module.css"],"names":[],"mappings":"AAAA;EACE,wDAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA,0EAA0E;AAC1E;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,oDAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;;EAElB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,8FAA8F;AAC9F;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,+FAA+F;AAC/F;EACE,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;EACzC,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;;EAEtC,gDAAgD;EAChD,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;;EAEtC,gDAAgD;EAChD,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,2BAA2B;AAC7B;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,yCAAyC;EACzC,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA;EACE,uBAAuB;EACvB,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,0CAA0C;EAC1C,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;;EAEN,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,kCAAkC;EAClC,wBAAwB;EACxB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,SAAW;AACb;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,sCAAsC;EACtC,gDAAgD;EAChD,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".root {\n  animation-name: heigthChangeBack;\n  animation-duration: 700ms;\n  position: relative;\n  background: white;\n  border: 1px solid lightgray;\n  border-radius: 6px;\n}\n\n.root.priority,\n.rootAnimation.priority {\n  border: 1px solid var(--color-theme-10);\n}\n\n/* Must win over .root / .rootAnimation border shorthand when both apply */\n.root.root_dotted_border,\n.rootAnimation.root_dotted_border {\n  border: 1px dashed lightgray;\n}\n\n.priority_pin {\n  position: absolute;\n  top: -15px;\n  left: -15px;\n  color: var(--color-theme-blue);\n  font-size: 15px;\n  transform: rotate(-45deg);\n  z-index: 1;\n}\n\n.received_email_container {\n  padding: 15px;\n}\n\n.rootFlex {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  margin: 8px 8px;\n}\n\n.rootAnimation {\n  animation-name: heigthChange;\n  animation-duration: 1500ms;\n  overflow: hidden;\n  position: relative;\n\n  background: white;\n  border: 1px solid lightgray;\n  border-radius: 6px;\n}\n\n/* Pin sits outside the box (negative top/left); overflow:hidden would clip it when expanded */\n.rootAnimation.priority {\n  overflow: visible;\n}\n\n.left_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-width: 115px;\n}\n\n.left_timestamp {\n  font-size: 10px;\n}\n\n.middle_container {\n  margin-left: 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-width: 165px;\n}\n\n.middle_type {\n  font-weight: bold;\n  margin-bottom: 7px;\n}\n\n.middle_user {\n  font-size: 12px;\n  font-weight: bold;\n}\n\n/* Shared content rows (email / scheduled / letter preview) — replaces repeated inline styles */\n.content_email_meta {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 400px;\n  white-space: nowrap;\n  color: #000;\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.content_subject_expanded {\n  width: 400px;\n}\n\n.content_subject_ellipsis {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 400px;\n  white-space: nowrap;\n}\n\n.type_subtext_scheduled_template {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 180px;\n  white-space: nowrap;\n}\n\n.letter_status_flex_row {\n  display: flex;\n  width: 400px;\n}\n\n.letter_status_text {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  max-width: 300px;\n  color: #000;\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.content_secondary_line {\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.mail_status_message {\n  text-align: center;\n}\n\n.attachment_chip {\n  height: 24px;\n  margin-right: 4px;\n}\n\n.are_you_sure_preline {\n  white-space: pre-line;\n}\n\n.info_popup_emphasis {\n  font-style: italic;\n}\n\n.dialog_actions_compact {\n  padding: 8px 16px 8px 8px;\n}\n\n.note_line {\n  margin: 0;\n  overflow: hidden;\n  width: 400px;\n  font-size: 16px;\n  line-height: 1.2;\n  min-height: 1.2em;\n}\n\n.note_line_truncated {\n  margin: 0;\n  overflow: hidden;\n  width: 400px;\n  font-size: 16px;\n  line-height: 1.2;\n  min-height: 1.2em;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.note_delete_icon_wrapper {\n  display: flex;\n}\n\n.note_collapsed_wrapper {\n  height: 39px;\n  font-size: 16px;\n}\n\n.right_container {\n  margin-left: 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 474px;\n}\n\n.letter_fail_reason {\n  text-align: start;\n  margin-inline-start: 40px;\n  font-size: 12px;\n  color: rgb(210, 177, 12);\n}\n\n.right_container_opener {\n  margin-left: 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  cursor: pointer;\n}\n\n.btn_confirm {\n  font-weight: bold !important;\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  margin-top: 10px;\n}\n\n.unread_marker {\n  border-radius: 10px;\n  width: 7px;\n  /* z-index: 20; */\n  height: 7px;\n  background-color: royalblue;\n  position: relative;\n  top: -29px;\n  left: 25px;\n  margin-bottom: -7px;\n}\n\n.btn_default {\n  color: var(--color-font-10) !important;\n\n  border: 1px solid rgba(0, 0, 0, 0.23) !important;\n  margin-top: 10px;\n  margin-right: 10px !important;\n}\n\n.btn_default_invisible {\n  color: var(--color-font-10) !important;\n\n  border: 1px solid rgba(0, 0, 0, 0.23) !important;\n  margin-top: 10px;\n  margin-right: 10px !important;\n  visibility: hidden;\n}\n.notePopupTextContainer {\n  max-height: 550px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.email_iframe {\n  width: 100%;\n  height: 500px;\n  border: none;\n}\n\n/* ── Right-side action column (delete, expand, menu) ── */\n.right_opener {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  align-self: stretch;\n}\n\n/* When there's no expand arrow, push the delete icon to the top */\n.right_opener_top {\n  justify-content: flex-start;\n}\n\n/* Unified delete icon across all card types */\n.delete_shopping_icon {\n  cursor: pointer;\n  font-size: 20px !important;\n  width: 20px;\n  height: 20px;\n}\n\n.delete_shopping_icon:hover {\n  color: var(--color-theme-red);\n}\n\n.delete_icon_disabled {\n  color: darkgray;\n  cursor: default;\n}\n\n.delete_icon_disabled:hover {\n  color: darkgray;\n}\n\n/* Expand chevron wrapper */\n.opener_expand_wrap {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.opener_expand_more {\n  font-size: 20px !important;\n  width: 20px;\n  height: 20px;\n}\n\n.edit_icon {\n  cursor: pointer;\n}\n\n.notePopupTextContainer::-webkit-scrollbar {\n  width: 8px !important;\n  display: inherit !important;\n  background-color: white !important;\n}\n\n.notePopupTextContainer::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 0px !important;\n  display: inherit !important;\n  width: 10px !important;\n}\n\n.notePopupActionsContainer {\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.gray {\n  rotate: 180deg;\n}\n\n.btn_confirm {\n  width: 100px;\n  margin-left: 15px !important;\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n}\n\n.btn_confirm:hover {\n  width: 100px;\n  margin-left: 15px !important;\n  color: var(--color-theme-white) !important;\n  background-color: var(--color-theme-blue) !important;\n}\n\n.btn_cancel {\n  width: 100px !important;\n  border: 1px solid var(--color-font-10) !important;\n  color: var(--color-font-10) !important;\n}\n\n.btn_cancel:hover {\n  width: 100px;\n  margin-left: 15px !important;\n  color: var(--color-theme-white) !important;\n  background-color: var(--color-font-10) !important;\n}\n\n.dialogContent {\n  margin-left: 5px;\n  margin-bottom: 30px;\n}\n\n.mailContainer {\n  border-top: 1px solid var(--color-theme-cloud);\n  margin-top: 14px;\n}\n\n.email_tools {\n  background: rgb(247 247 247);\n  position: sticky;\n  top: 0;\n\n  border-bottom: 1px solid lightgray;\n  padding: 4px 4px;\n  width: calc(100% + 8px);\n}\n\n.email_resend_container {\n  /* background: rgb(0 0 0 / 3%); */\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  border-bottom: 1px solid lightgray;\n  padding: 4px 0px 4px 4px;\n  width: calc(100% + 8px);\n  right: 8px;\n}\n.resend_text {\n  /* color: var(--color-theme-yellow); */\n  color: rgb(233, 170, 12);\n  margin: auto 0 auto 10px;\n}\n\n.warning_icon {\n  color: var(--color-theme-yellow);\n}\n\n.scheduled_text_container {\n  padding: 8px;\n}\n\n.payment_received_container {\n  padding: 16px 8px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 160px;\n  min-width: 0;\n}\n\n.payment_received_company_info_block {\n  margin-left: 20px;\n  display: flex;\n  flex-direction: column;\n  min-width: 220px;\n  max-width: 320px;\n  flex: 1 1 220px;\n  box-sizing: border-box;\n}\n\n.payment_received_company_info_block > div {\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.payment_received_email_block_label {\n  min-width: 70px;\n  display: inline-block;\n  margin-right: 16px;\n  margin-bottom: 0;\n  text-align: left;\n}\n\n.payment_received_address_block {\n  margin: 0;\n  min-width: 220px;\n  max-width: 320px;\n  flex: 1 1 220px;\n  box-sizing: border-box;\n}\n\n.payment_received_address_block > strong {\n  display: block;\n  margin-bottom: 10px;\n}\n.payment_received_email_block_label {\n  min-width: 70px;\n  display: inline-block;\n}\n\n.attachement_row {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.attachment_button_container {\n  position: absolute;\n  right: 0px;\n  top: 4px;\n}\n\n.license_icon_high {\n  color: var(--color-theme-blue);\n}\n\n.license_content {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  min-width: 0;\n  flex: 1 1 0;\n}\n\n.license_filename {\n  flex: 1 1 0;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.license_filename_with_status {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.license_filename_text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.license_deleted {\n  flex-shrink: 0;\n  margin-left: 2px;\n}\n\n.license_filename > a,\n.license_filename > span:not(.license_filename_with_status) {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.license_file_link {\n  text-decoration: none;\n  color: inherit;\n  cursor: pointer;\n  position: relative;\n  z-index: 1;\n}\n\n.license_file_link:hover {\n  text-decoration: underline;\n  color: var(--color-theme-blue);\n}\n\n.license_actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.btn_check_license {\n  font-size: 11px !important;\n  text-transform: uppercase !important;\n  white-space: nowrap;\n  color: var(--color-font-10) !important;\n  border: 1px solid rgba(0, 0, 0, 0.23) !important;\n  padding: 2px 8px !important;\n  align-self: center;\n  margin: 0 30px !important;\n}\n\n@keyframes heigthChange {\n  from {\n    max-height: 56px;\n  }\n  to {\n    max-height: 4000px;\n  }\n}\n\n@keyframes heigthChangeBack {\n  from {\n    max-height: 900px;\n  }\n  to {\n    max-height: 56px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CaseActivityCard_root__nqP+c`,
	"heigthChangeBack": `CaseActivityCard_heigthChangeBack__H4jwe`,
	"priority": `CaseActivityCard_priority__rocBa`,
	"rootAnimation": `CaseActivityCard_rootAnimation__SDhO3`,
	"root_dotted_border": `CaseActivityCard_root_dotted_border__WRBQH`,
	"priority_pin": `CaseActivityCard_priority_pin__VxqFL`,
	"received_email_container": `CaseActivityCard_received_email_container__Szs7t`,
	"rootFlex": `CaseActivityCard_rootFlex__Wx0CA`,
	"heigthChange": `CaseActivityCard_heigthChange__cYFhT`,
	"left_container": `CaseActivityCard_left_container__r6s7I`,
	"left_timestamp": `CaseActivityCard_left_timestamp__wbHM3`,
	"middle_container": `CaseActivityCard_middle_container__jpZIF`,
	"middle_type": `CaseActivityCard_middle_type__2BC4y`,
	"middle_user": `CaseActivityCard_middle_user__QYfNI`,
	"content_email_meta": `CaseActivityCard_content_email_meta__Y2Aqo`,
	"content_subject_expanded": `CaseActivityCard_content_subject_expanded__hhup6`,
	"content_subject_ellipsis": `CaseActivityCard_content_subject_ellipsis__7vDvD`,
	"type_subtext_scheduled_template": `CaseActivityCard_type_subtext_scheduled_template__8niyK`,
	"letter_status_flex_row": `CaseActivityCard_letter_status_flex_row__Phb-e`,
	"letter_status_text": `CaseActivityCard_letter_status_text__8ugI2`,
	"content_secondary_line": `CaseActivityCard_content_secondary_line__8Cmlh`,
	"mail_status_message": `CaseActivityCard_mail_status_message__76kFs`,
	"attachment_chip": `CaseActivityCard_attachment_chip__1Dw3F`,
	"are_you_sure_preline": `CaseActivityCard_are_you_sure_preline__k-ZCt`,
	"info_popup_emphasis": `CaseActivityCard_info_popup_emphasis__OGRqs`,
	"dialog_actions_compact": `CaseActivityCard_dialog_actions_compact__A2Vjd`,
	"note_line": `CaseActivityCard_note_line__CJe7k`,
	"note_line_truncated": `CaseActivityCard_note_line_truncated__waxar`,
	"note_delete_icon_wrapper": `CaseActivityCard_note_delete_icon_wrapper__A1yX2`,
	"note_collapsed_wrapper": `CaseActivityCard_note_collapsed_wrapper__lWBxD`,
	"right_container": `CaseActivityCard_right_container__4X3cB`,
	"letter_fail_reason": `CaseActivityCard_letter_fail_reason__S8A-5`,
	"right_container_opener": `CaseActivityCard_right_container_opener__UH6MM`,
	"btn_confirm": `CaseActivityCard_btn_confirm__dv1-7`,
	"unread_marker": `CaseActivityCard_unread_marker__BhXhW`,
	"btn_default": `CaseActivityCard_btn_default__gsASm`,
	"btn_default_invisible": `CaseActivityCard_btn_default_invisible__tOfMk`,
	"notePopupTextContainer": `CaseActivityCard_notePopupTextContainer__qMuLt`,
	"email_iframe": `CaseActivityCard_email_iframe__hrK9u`,
	"right_opener": `CaseActivityCard_right_opener__ZyNjZ`,
	"right_opener_top": `CaseActivityCard_right_opener_top__I4gpB`,
	"delete_shopping_icon": `CaseActivityCard_delete_shopping_icon__GB0sm`,
	"delete_icon_disabled": `CaseActivityCard_delete_icon_disabled__gDbcX`,
	"opener_expand_wrap": `CaseActivityCard_opener_expand_wrap__H997Q`,
	"opener_expand_more": `CaseActivityCard_opener_expand_more__In7rO`,
	"edit_icon": `CaseActivityCard_edit_icon__UdFGP`,
	"notePopupActionsContainer": `CaseActivityCard_notePopupActionsContainer__qZgY0`,
	"gray": `CaseActivityCard_gray__W8223`,
	"btn_cancel": `CaseActivityCard_btn_cancel__I9ceg`,
	"dialogContent": `CaseActivityCard_dialogContent__Y6nIq`,
	"mailContainer": `CaseActivityCard_mailContainer__NrH4H`,
	"email_tools": `CaseActivityCard_email_tools__9i3tE`,
	"email_resend_container": `CaseActivityCard_email_resend_container__EBIit`,
	"resend_text": `CaseActivityCard_resend_text__H7g9x`,
	"warning_icon": `CaseActivityCard_warning_icon__nV6Xy`,
	"scheduled_text_container": `CaseActivityCard_scheduled_text_container__yf71x`,
	"payment_received_container": `CaseActivityCard_payment_received_container__FyxUM`,
	"payment_received_company_info_block": `CaseActivityCard_payment_received_company_info_block__pSAJm`,
	"payment_received_email_block_label": `CaseActivityCard_payment_received_email_block_label__pHAlj`,
	"payment_received_address_block": `CaseActivityCard_payment_received_address_block__m54R+`,
	"attachement_row": `CaseActivityCard_attachement_row__oPiCV`,
	"attachment_button_container": `CaseActivityCard_attachment_button_container__f+QWu`,
	"license_icon_high": `CaseActivityCard_license_icon_high__WqKkk`,
	"license_content": `CaseActivityCard_license_content__rehwW`,
	"license_filename": `CaseActivityCard_license_filename__VlJv1`,
	"license_filename_with_status": `CaseActivityCard_license_filename_with_status__OZbnD`,
	"license_filename_text": `CaseActivityCard_license_filename_text__Enq6h`,
	"license_deleted": `CaseActivityCard_license_deleted__R0yu3`,
	"license_file_link": `CaseActivityCard_license_file_link__T3h6O`,
	"license_actions": `CaseActivityCard_license_actions__mZHyU`,
	"btn_check_license": `CaseActivityCard_btn_check_license__EQ5+t`
};
export default ___CSS_LOADER_EXPORT___;
